<mat-progress-spinner
  [mode]="input.mode | parse: context | async"
  [color]="color"
  [diameter]="(input.diameter | parse: context | async) ?? 24"
  [strokeWidth]="(input.strokeWidth | parse: context | async) ?? 2"
  [value]="input.value | parse: context | async"
  [matTooltip]="tooltipText"
  [matTooltipPosition]="tooltipPosition"
/>
